import { memo } from "react";

import { useHandleTextFieldChange } from "services/forms/hooks";
import { CheckBox } from "ui/components/CheckBox";
import { TextField } from "ui/components/TextField/TextField";
import { TextArea } from "ui/components/TextField/TextArea";
import { EmailTextField } from "ui/components/TextField/EmailTextField";
import { Alert } from "ui/components/Alert";
import { EmailContentSectionProps } from "./types";


const EmailContentSection: React.FC<EmailContentSectionProps> = (props) => {
  const {
    formValues,
    setFormValues,
    noteText,
    senderEmail,
    tenantEmail,
  } = props;

  const handleTextFieldChange = useHandleTextFieldChange(setFormValues, formValues);

  return (
    <div className="flex-1">
      <div className="mb-4">
        <div className="mb-3">
          <div className="flex gap-4">
            {/* Predmet */}
            <div className="mb-4 flex-1">
              <TextField
                name="subject"
                label="Predmet:"
                type="text"
                value={formValues.subject}
                onChange={handleTextFieldChange}
                disableDebounce
              />
            </div>
            {/* Adresa za odgovor */}
            <div className="mb-4">
              <EmailTextField
                name="replyTo"
                label="Adresa za odgovor:"
                value={formValues.replyTo}
                onChange={handleTextFieldChange}
                disableDebounce
              />
            </div>
          </div>
          {/* Sadržaj */}
          <div className="mb-4">
            <TextArea
              name="content"
              label="Sadržaj:"
              value={formValues.content}
              onChange={handleTextFieldChange}
              rows={12}
              disableDebounce
            />
          </div>
        </div>
        <div className="flex flex-col  border border-slate-200 px-3 pt-3 pb-1 mb-3">
          {/* Napomena */}
          <Alert variant="info" message={noteText} />
          <div className="flex items-center gap-2 mt-3">
            <span className="text-sm font-medium text-gray-700">Šalje: </span>
            <span className="text-sm text-gray-600">{senderEmail}</span>
          </div>
          <div className="flex items-center justify-between gap-2">
            <div className="flex items-center gap-2">
              <span className="text-sm font-medium text-gray-700">Kopija poruke: </span>
              <span className="text-sm text-gray-600">{tenantEmail}</span>
            </div>
            <div className="mt-2">
              <CheckBox
                name="ccTenantEmail"
                checked={formValues.ccTenantEmail}
                onChange={() => setFormValues((prev) => ({ ...prev, ccTenantEmail: !prev.ccTenantEmail }))}
                label="pošalji mi kopiju poruke"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(EmailContentSection);
